import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useGetClientList } from '../../../../interface/common';
import theme from '../../../../styles/theme';
import Button from '../../../common/Button';
import CommonDataGrid from '../../../common/CommonDataGrid';
import MsgModal from '../../../common/modal/MsgModal';
import ClientForm from './ClientForm';


const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    h3 {
        font-size: ${theme.fontSize.base};
        font-weight: 600;
        margin: 0;
        color: ${theme.color.black};
    }
    div {
        color: ${theme.color.black};
        font-size: ${theme.fontSize.base};
    }
    transition: ${theme.windowSize.drawerTransition};
`;

const columns = [
    // { field: 'cid', headerName: '표기번호', width:100 },
    // { field: 'o_ret_stnm', headerName: '반출상태', flex:0.5 },
    { field: 'cnm', headerName: '거래처명', width:310 },
    { field: 'is_gov_nm', headerName: '업체구분', width:120 },
    { field: 'biz_no', headerName: '사업자번호', width:200 },
    { field: 'phn_no', headerName: '전화번호', width:165 },
    { field: 'owner', headerName: '대표명', width:200 },
    { field: 'addr', headerName: '주소', width:400 },
    // { field: 'reg_dt', headerName: '자산번호', width:140},
    { field: 'descr', headerName: '설명', width:300},
]

const Client = () => {

    const [clientList, setClientList] = useState([]);
    const [regOpen, setRegOpen] = useState(false);
    const [target, setTarget] = useState();

    const { data : cList, isLoading: cListLoading} = useGetClientList();

    useEffect(()=>{
        if(cList){
            setClientList(cList.map((item,index)=>({
                ...item,
                id: index,
                is_gov_nm: item.is_gov === 1 ? '기관' : '일반',
                label:item.cnm})
                ));
        }
    },[cList])

    return (
        <MainWrap>
            <div style={{display:'flex',justifyContent:'flex-end',alignItems:'center'}}>
                <Button onClick={()=>{setTarget();setRegOpen(true);}} style={{width:'150px'}}>거래처추가</Button>
            </div>
            <div style={{height:'0.8rem'}} />
            <div style={{height:'80vh'}}>
            <CommonDataGrid
                isLoading={cListLoading}
                list={clientList}
                columns={columns}
                onRowClick={(e)=>{setTarget(e.row);setRegOpen(true);}}
                />
            </div>
            <MsgModal open={regOpen}>
                <DetailWrap target={target} onClose={setRegOpen} />
            </MsgModal>
        </MainWrap>
    )

}

const DetailWrapStyle = styled.div`
    width: 100%;
    height: 100%;
    // border: 1px solid red;
`;

const DetailWrap = ({target, onClose}) => {
    return (
        <DetailWrapStyle>
            <ClientForm target={target} onClose={onClose}/>
        </DetailWrapStyle>
    )
}

export default Client;
